import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.ar'

export default createLendingBundle(whitepaper)
